import Select from 'react-select'
//Select с поиском
function SelectSearchV2({ options, defaultValue, name, className, placeholder, disabled, onChange }) {
    /*
    ФОРМАТ options:
    {value: '', label: '', checked: ''}

    ЗНАЧЕНИЕ defaultValue:
    указывается полностью модель: {value: '',    label: '',    checked: ''}
    */
    return (
        <>
            {name != undefined && (
                <label className="form-label">{name}</label>
            )}
            <Select name={name} options={options} placeholder={placeholder} defaultValue={defaultValue} className={className} isDisabled={disabled} onChange={onChange} />
        </>
    )
}
export default SelectSearchV2;